import { render, staticRenderFns } from "./VerifyAccount.vue?vue&type=template&id=54f1d7f8&scoped=true"
import script from "./VerifyAccount.vue?vue&type=script&lang=js"
export * from "./VerifyAccount.vue?vue&type=script&lang=js"
import style0 from "./VerifyAccount.vue?vue&type=style&index=0&id=54f1d7f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f1d7f8",
  null
  
)

export default component.exports